export default "__VITE_ASSET__NVOn5aMF__"